import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory, useLocation } from 'react-router';
import styled from 'styled-components';
import { AddButton } from 'components/atoms/button';
import { TableSkeleton } from 'components/atoms/table';
import { useGetKeyEventMutationsForRefId } from 'hooks/use-key-events';
import { useTranslate } from 'hooks/use-translation';
import { KeyEventsEmptyState } from './key-events-empty-state';
import { ListKeyEvents } from './list-key-events';

interface Props {
  refType: 'phase' | 'task';
  refId: number;
  templateId: number;
}

const Wrapper = styled.div`
  background: var(--white-100);
`;

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  padding: var(--spacing-05);
  padding-bottom: var(--spacing-03);
`;

const AutomateText = styled.p`
  display: flex;
  align-items: center;
  margin-bottom: 0;
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-lg);
`;

export const KeyEventsTab: React.FC<Props> = ({
  refId,
  refType,
  templateId,
}) => {
  const translate = useTranslate();
  const history = useHistory();
  const location = useLocation();

  const { isLoading, data: automations } = useGetKeyEventMutationsForRefId(
    templateId,
    refType,
    refId,
  );

  const onClick = async () => {
    history.push(`${location.pathname}/automations/${refType}/${refId}`);
  };

  if (isLoading) {
    return <TableSkeleton columnCount={3} rowCount={5} />;
  }

  return (
    <Wrapper>
      {automations?.length ? (
        <HeaderWrapper>
          <>
            <AutomateText>
              <FormattedMessage id="templates.tab.key_events.automate_recording" />
            </AutomateText>
            <AddButton onClick={onClick}>
              {translate('templates.tab.key_events')}
            </AddButton>
          </>
        </HeaderWrapper>
      ) : null}
      {automations !== undefined ? (
        automations.length > 0 ? (
          <ListKeyEvents
            templateId={templateId}
            automations={automations}
            refId={refId}
            refType={refType}
          />
        ) : (
          <KeyEventsEmptyState refId={refId} refType={refType} />
        )
      ) : null}
    </Wrapper>
  );
};
